var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-box"},[_c('div',{staticClass:"settings-row"},[_c('profile')],1),_c('div',{staticClass:"settings-row"},[_c('change-password')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }